import React from 'react';
import HeroSection from './Home/HeroSection';
import FeaturedProperties from './Home/FeaturedProperties';
import CitySection from './Home/CitySection';
import RecommendedProperties from './Home/ResidentialProperties';
import NewlyAdded from './Home/NewlyAdded';
import WhyChooseUs from './Home/WhyChooseUs';

const Main = () => {
  return (
    <>
      <HeroSection />
      <NewlyAdded />
      
      <CitySection />
      <RecommendedProperties />
      <FeaturedProperties />
      <WhyChooseUs />
    </>
  );
};

export default Main;